import { Params, RouterStateSnapshot } from '@angular/router';
import { IRouteData } from '@mnz-core/models/router-data';
import { RouterStateSerializer } from '@ngrx/router-store';

export interface RouterStateUrl {
  url: string;
  params: Params;
  queryParams: Params;
  data: IRouteData;
}

export class RouterStoreSerializer implements RouterStateSerializer<RouterStateUrl> {
  serialize(routerState: RouterStateSnapshot): RouterStateUrl {
    let route = routerState.root;

    while (route.firstChild) {
      route = route.firstChild;
    }

    const {
      url,
      root: { queryParams }
    } = routerState;

    const { params, data } = route;

    return { url, params, queryParams, data };
  }
}
